import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  card: {
    width: "480px",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    padding: "32px 40px",
    boxSizing: "border-box",
    textAlign: "left",
    maxHeight: "calc(100svh - 64px - 32px)",
    overflowY: "auto",
    overflowX: "hidden", // Prevents bug found of moving the children inside the card horizontally

    scrollbarWidth: "none",
    msOverflowStyle: "none" // Internet Explorer and Edge older versions
  },

  title: {
    margin: "0 0 16px",
    fontSize: "24px",
    color: "#333333",
    fontFamily: "sauna-new",
    fontWeight: "400"
  }
};
